import { fg } from '@confluence/feature-gating';

export const isClickEventToOpenNewTab = <E extends React.SyntheticEvent | undefined>(
	event: E,
	options?: {
		shouldCheckIframe?: boolean;
	},
): boolean | undefined => {
	return (
		event?.isDefaultPrevented() &&
		((Boolean(options?.shouldCheckIframe) && isIframe()) ||
			isCtrlOrCommandClick(event) ||
			isMiddleClick(event))
	);
};

const isIframe = () => window.parent !== parent;

const isMiddleClick = (event: Parameters<typeof isClickEventToOpenNewTab>[0]): boolean => {
	const nativeEvent = event?.nativeEvent as MouseEvent;

	return nativeEvent.button === 1;
};

const isCtrlOrCommandClick = (event: Parameters<typeof isClickEventToOpenNewTab>[0]): boolean => {
	const nativeEvent = event?.nativeEvent as MouseEvent;

	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	return fg('platform-smart-card-shift-key')
		? nativeEvent.ctrlKey || nativeEvent.metaKey || nativeEvent.shiftKey
		: nativeEvent.ctrlKey || nativeEvent.metaKey;
};
